<template>
  <section id="contactdetails" class="section contact">
    <div class="section-container contact-grid reveal">
      <aside class="contact-brand card">
        <img
          src="@/assets/logo remove.png"
          alt="Abercode Logo"
          loading="lazy"
          decoding="async"
        />
        <p>
          Wujudkan kebutuhan proyek Anda bersama tim yang memahami proses
          bisnis dan implementasi teknologi end-to-end.
        </p>

        <div class="social-links">
          <a
            v-for="social in socials"
            :key="social.href"
            :href="social.href"
            target="_blank"
            rel="noreferrer"
            :aria-label="social.label"
          >
            <ion-icon :name="social.icon"></ion-icon>
          </a>
        </div>
      </aside>

      <div class="contact-panel card">
        <span class="section-label">Detail Kontak</span>
        <h2 class="section-title">Hubungi kami melalui kanal berikut</h2>
        <p class="section-copy">
          Tim kami siap berdiskusi untuk kebutuhan pengembangan produk, sistem
          internal, hingga konsultasi transformasi digital.
        </p>

        <a
          v-for="item in contacts"
          :key="item.title"
          :href="item.href"
          class="contact-item"
          :target="item.external ? '_blank' : null"
          :rel="item.external ? 'noreferrer' : null"
        >
          <span class="contact-icon">
            <ion-icon :name="item.icon"></ion-icon>
          </span>
          <span>
            <strong>{{ item.title }}</strong>
            <small>{{ item.value }}</small>
          </span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactDetails",
  data() {
    return {
      contacts: [
        {
          title: "WhatsApp",
          value: "+62 851 6281 4545",
          icon: "logo-whatsapp",
          href: "https://wa.me/6285162814545",
          external: true,
        },
        {
          title: "Email",
          value: "abercode.software@gmail.com",
          icon: "mail-outline",
          href: "mailto:abercode.software@gmail.com",
          external: false,
        },
        {
          title: "Alamat",
          value: "Jl. Sukarsia No. 73, Bandung, Jawa Barat, Indonesia 40125",
          icon: "location-outline",
          href:
            "https://www.google.com/maps/place/J.+Sukarsia+no.+73,+Bandung,+Jawa+Barat,+Indonesia+40125",
          external: true,
        },
      ],
      socials: [
        {
          label: "LinkedIn",
          icon: "logo-linkedin",
          href: "https://www.linkedin.com/company/abercode-software-innovation/",
        },
        {
          label: "Instagram",
          icon: "logo-instagram",
          href: "https://www.instagram.com/abercode.software/",
        },
        {
          label: "Situs Web",
          icon: "globe-outline",
          href: "https://www.abercode.com",
        },
      ],
    };
  },
};
</script>

<style scoped>
.contact {
  padding-top: 28px;
}

.contact-grid {
  display: grid;
  grid-template-columns: 0.88fr 1.12fr;
  gap: 16px;
}

.contact-brand,
.contact-panel {
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.76);
}

.contact-brand {
  background: linear-gradient(160deg, #fff, #f3f7ff);
}

.contact-brand img {
  width: min(260px, 100%);
}

.contact-brand p {
  margin-top: 12px;
  font-size: 0.95rem;
}

.social-links {
  margin-top: 18px;
  display: flex;
  gap: 10px;
}

.social-links a {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #fff;
  border: 1px solid var(--border);
  color: var(--primary);
  transition: transform 0.22s ease, background 0.22s ease;
}

.social-links a:hover {
  transform: translateY(-2px);
  background: var(--surface-muted);
}

.social-links ion-icon {
  font-size: 1.2rem;
}

.contact-panel {
  background: #fff;
}

.contact-panel .section-title {
  margin-top: 4px;
}

.contact-panel .section-copy {
  margin-top: 10px;
}

.contact-item {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: var(--radius-s);
  border: 1px solid rgba(13, 77, 164, 0.12);
  background: #fdfdff;
  transition: border-color 0.22s ease, transform 0.22s ease;
}

.contact-item:hover {
  transform: translateY(-2px);
  border-color: rgba(13, 77, 164, 0.32);
}

.contact-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: rgba(13, 77, 164, 0.1);
  color: var(--primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.contact-icon ion-icon {
  font-size: 1.2rem;
}

.contact-item strong {
  display: block;
  font-size: 0.96rem;
  color: var(--text);
}

.contact-item small {
  display: block;
  margin-top: 2px;
  color: var(--muted);
  line-height: 1.5;
}

@media (max-width: 920px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
}
</style>
